module.exports = __webpack_public_path__ + "img/games-text.8ada0744.webp";